import React from "react";
import { useEffect } from "react";
import { ProductHeroSection } from "@tennr/frontend/sections/ProductHeroSection";
import { Heading } from "@tennr/frontend/components/Heading";
import { ProductFeaturesSection } from "@tennr/frontend/sections/ProductFeaturesSection";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import "./ProductPage.css";

const bgImage = "/img/product-hero-bg.jpg";
const bgImageVert = "/img/product-hero-bg-vert2.jpg";

export const ProductPage: React.FC = () => {
  useEffect(() => {
    const preload = (src?: string) => {
      if (!src) return;
      const img = new Image();
      img.src = src;
    };

    const isMobile = window.innerWidth <= 768 || window.matchMedia("(orientation: portrait)").matches;

    if (isMobile) {
      // Preload vertical/mobile images
      preload("/img/homepage-hero-bg-vert2.jpg");
      preload("/img/product-hero-bg-vert2.jpg");
      preload("/img/customer-stories-hero-bg-vert.jpg");
      preload("/img/about-us-hero-bg-vert.jpg");
      preload("/img/case-study-hero-bg-vert.jpg");
      preload("/img/book-demo-hero-bg-vert.jpg");
    } else {
      // Preload desktop images
      preload("/img/homepage-hero-bg.jpg");
      preload("/img/product-hero-bg.jpg");
      preload("/img/customer-stories-hero-bg.jpg");
      preload("/img/about-us-hero-bg.jpg");
      preload("/img/case-study-hero-bg.jpg");
      preload("/img/book-demo-hero-bg.jpg");
    }

    preload("/img/grain.png"); // always used
  }, []);

  return (
    <>
      <MetadataTags
        title="Product | Tennr"
        description="Tennr uses the most advanced models in healthcare for document wrangling, intake, benefits investigations, clinical qualifications, and patient communication."
        imageUrl="https://tennr.com/share_cards/sharecard-product.webp"
      />
      <main className="product-page">
        <PageBackground bgImage={bgImage} bgImageVert={bgImageVert} />
        <ProductHeroSection />
        <section className="product-features-intro">
          <Heading
            title="Here's How"
            heading={"The most advanced\nmodels in healthcare"}
            body="Tennr is trained on over 100M medical documents, 2.3B distinct data fields, and 8,000 sets of criteria. Here's what happens in practice."
            color="dark"
            variant="hero"
            position="center"
            width={730}
            mobileMaxWidth={405}
          />
        </section>
        <ProductFeaturesSection />
      </main>
      <SiteFooter
        taglinePosition="left"
        bgImage="/img/footer-product-bg.jpg"
        bgImageVert="/img/footer-product-bg-vert.jpg"
      />
    </>
  );
};
